import Component from '../core/Component'

export default class ImageSlider extends Component {
	constructor(element, options) {
		super(element, options)

		this.ref = {
			itemContainer: null,
			dotContainer: null,
			prev: null,
			next: null,
			counter: null,
			items: [],
		}

		this.index = null
		this.zIndex = 2
		this.preventTimer = null
	}

	prepare() {
		this.ref.dotContainer.addEventListener('click', this.handleDotContainerClick)
		this.ref.dotContainer.addEventListener('animationend', this.handleDotContainerAnimationEnd)
        this.ref.itemContainer.addEventListener('click', this.handleItemContainerClick)
		this.ref.prev.addEventListener('click', this.handlePrevClick)
		this.ref.next.addEventListener('click', this.handleNextClick)
		this.createDots()

        this.observer = new IntersectionObserver(this.handleIntersection)
        this.observer.observe(this.element)
	}

	handlePrevClick = () => {
		this.selectPrev()
	}

	handleNextClick = () => {
		this.selectNext()
	}

	handleIntersection = (entries) => {
		if (!entries[0].isIntersecting) {
			return
		}
		this.observer.disconnect()
		this.observer = null
        this.select(0)
	}

	handleDotContainerClick = (event) => {
		const spanEl = event.target.closest('span')
		if (!spanEl) {
			return
		}
		const spanEls = [...spanEl.parentNode.children]
		const index = spanEls.indexOf(spanEl)
		if (index < 0) {
			return
		}
		this.select(index)
		this.switchToManual()
	}

    handleItemContainerClick = () => {
		this.switchToManual()
    }

	handleDotContainerAnimationEnd = (event) => {
		const spanEl = event.target.closest('span')
		if (!spanEl) {
			return
		}
		const spanEls = [...spanEl.parentNode.children]
		const index = spanEls.indexOf(spanEl)
		if (index < 0) {
			return
		}
		this.selectNext()
	}

	createDots() {
		this.ref.dotContainer.innerHTML = `
            ${this.ref.items.map(() => '<span></span>').join('')}
        `
	}

	select(index) {
		if (this.preventTimer) {
			return
		}
		if (this.index === index) {
			return
		}

		let isBackwards = this.index > index || (index === this.ref.items.length - 1 && this.index === 0)
		if (index !== 0 && this.index !== this.ref.items.length-1) {
			isBackwards = false
		}
		if ((this.index === this.ref.items.length - 1 && index === 0)) {
			isBackwards = false
		}
		if ((this.index === 0 && index === this.ref.items.length-1)) {
			isBackwards = true
		}
		this.element.classList.toggle('is-backwards', isBackwards)

		const spanEls = [...this.ref.dotContainer.children]
		spanEls.forEach((spanEl, _index) => {
			const item = this.ref.items[_index]
			const isActive = index === _index

			spanEl.classList.toggle('is-active', isActive)
			item.classList.toggle('is-active', isActive)
			if (isActive) {
				item.style.zIndex = this.zIndex
				this.zIndex += 1
			}
		})

		this.index = index

		this.ref.counter.innerHTML = `${index+1} / ${this.ref.items.length}`
		this.preventTimer = setTimeout(() => {
			this.preventTimer = null
		},900)
	}

	selectNext() {
		const index = this.index + 1
		this.select(this.ref.items.length > index ? index : 0)
	}

	selectPrev() {
		const index = this.index - 1
		this.select(index >= 0 ? index : this.ref.items.length - 1)
	}


	switchToManual() {
        clearTimeout(this.timer)
        this.element.classList.add('is-manual')
	}
}
